import { render, staticRenderFns } from "./JoinToGroup.vue?vue&type=template&id=c76369c0&lang=pug&"
import script from "./JoinToGroup.vue?vue&type=script&lang=js&"
export * from "./JoinToGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports